module.exports = __webpack_public_path__ + "img/services3.fcac0117.jpg";